<script>
import { VStepper } from 'vuetify/lib';
export default VStepper;
</script>
